import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";

const CookieConsentBanner = ({  err, setErr }) => {
  const [cookies, setCookie] = useCookies(["userConsent"]);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!cookies.userConsent) {
      setShowBanner(true);
    }
  }, [cookies]);

 

  const handleAccept = () => {
    setCookie("userConsent", "accepted", {
      path: "/",
      maxAge: 14 * 24 * 60 * 60,
    });
    setShowBanner(false);
  };

  const handleReject = () => {
    setCookie("userConsent", "rejected", {
      path: "/",
      maxAge: 14 * 24 * 60 * 60,
    });
    setShowBanner(false);
  };

  return (
    <>
      {showBanner && (
        <div className="cookie-consent">
          <p style={{ color:  "white" }}>
            We use cookies to enhance your browsing experience, serve
            personalized ads or content, and analyze our traffic. By clicking
            "Accept All", you consent to our use of cookies.{" "}
            {/* Uncomment the link below if needed */}
            {/* <a href="/cookie-policy" target="_blank" rel="noopener noreferrer">
                  Cookie Policy
                </a> */}
          </p>
          <div className="buttons">
            <button onClick={handleAccept}>Accept All</button>
             <button onClick={handleReject}>Reject All</button>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieConsentBanner;
